import { Component, OnInit } from '@angular/core';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { withAuxBackground, withBubbles, withFreespinLogo, withParagraph } from './behaviours-by-class';
import { trigger, style, animate, transition, state } from '@angular/animations';

@Component({
  selector: 'app-casino-promo-box',
  templateUrl: './component' + environment.multisite.view + '-promo-box.html',
  styleUrls: ['./casino-promo-box.component.scss'],
  animations: [
    trigger('fade', [transition('void => *', [style({ opacity: 0 }), animate(2000, style({ opacity: 1 }))])]),
    trigger('fly-left', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [style({ transform: 'translateX(-100%)' }), animate(800)])
    ]),
    trigger('fly-right', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [style({ transform: 'translateX(100%)' }), animate(800)])
    ])
  ]
})
export class CasinoPromoBoxComponent implements OnInit {
  public upLogIn: boolean;
  public bubbles: number;
  public showFreespinLogo: boolean;
  public showAuxiliarBackground: boolean;
  public showCharacterParagraph: boolean;
  public name: string = environment.multisite.name;

  constructor(protected _window: WindorefService, protected _storage: StoragePermissionService, protected _translate: TranslateService) {}

  ngOnInit(): void {
    this.saveStaticPromoGame();
    this._setLandingBehaviours();
  }

  private _setLandingBehaviours(): void {
    this._translate.get('class').subscribe((value) => {
      this.bubbles = withBubbles.some((wb) => value === wb) ? 10 : 0;
      this.showFreespinLogo = withFreespinLogo.some((wFL) => value === wFL);
      this.showAuxiliarBackground = withAuxBackground.some((wAB) => value === wAB);
      this.showCharacterParagraph = withParagraph.some((wp) => value === wp);
    });
  }

  saveStaticPromoGame(): void {
    if (environment.multisite.view == '.simple-casino') {
      this._translate.get('Promo').subscribe((value) => {
        if (typeof value === 'object') {
          let { id, code } = value;
          let casino = { game: id, promo: code };
          this._storage.setCasinoGame(casino);
        }
      });
    }
  }

  showLogin(id: number, promo: string) {
    let casino = { game: id, promo: promo };
    this._storage.setCasinoGame(casino);
    this.upLogIn = true;
    this._window.getNativeWindow().document.body.scrollTop = 0;
    this._window.getNativeWindow().document.documentElement.scrollTop = 0;
  }

  hideLogin(): void {
    this.upLogIn = false;
  }
}
